import StylusFrame from './StylusFrame';
import FrameDrawingBrush, {
  type StylusFrameOptions,
} from './FrameDrawingBrush';
import autolayoutIcon from '../assets/icons/autolayoutMenuIcon.svg';
import { svgToIcon } from '../utils/svg';

// Autolayout frame - extends StylusFrame directly, not StylusFrameRatio
class StylusFrameAutolayout extends StylusFrame {
  constructor({ controller }) {
    super({ controller });
  }

  iconClass() {
    return 'fa-regular fa-square'; // Fallback
  }

  renderIcon() {
    return svgToIcon(autolayoutIcon);
  }

  description() {
    return 'Blank';
  }

  stylusId() {
    return 'frame-autolayout';
  }

  activate() {
    const options: StylusFrameOptions = {
      layoutEnabled: true,
    };

    const brush = new FrameDrawingBrush(this.controller.canvas, this, options);
    this.controller.canvas.isDrawingMode = true;
    this.controller.canvas.freeDrawingBrush = brush;
  }
}

export default StylusFrameAutolayout;
